import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useAuth0Token } from './hooks/useAuth0Token';
import { useHistory } from 'react-router-dom';
import LoadingScreen from './components/LoadingScreen';
import { CLIENT_SIGNUP_PATH, rememberSignupIntent } from '../services/api/accountService';
import { isMarketplaceEnabled } from '../utils/config';

/**
 * `/get-help` is the door for people looking for a lawyer (pons.io links
 * here). It remembers that they are a client and opens Auth0 on SIGN-UP
 * rather than log-in; the app picks the intent up once they are signed in.
 */
const isClientSignup = () => isMarketplaceEnabled() && window.location.pathname === CLIENT_SIGNUP_PATH;

const Auth0Routes: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading, loginWithRedirect, handleRedirectCallback } = useAuth0();
  const { getToken, isLoading: tokenLoading } = useAuth0Token();
  const [loginTriggered, setLoginTriggered] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (!isLoading && !isAuthenticated && !loginTriggered) {
      setLoginTriggered(true);
      const clientSignup = isClientSignup();
      if (clientSignup) rememberSignupIntent('client');
      const returnTo = clientSignup ? '/' : window.location.pathname + window.location.search;
      loginWithRedirect({
        authorizationParams: {
          screen_hint: clientSignup ? 'signup' : 'login',
        },
        appState: { returnTo },
      });
    }
  }, [isLoading, isAuthenticated, loginTriggered, loginWithRedirect]);

  useEffect(() => {
    if (isAuthenticated) {
      const stored = sessionStorage.getItem('auth0_return_to');
      if (stored && stored !== '/' && stored !== '/dashboard') {
        sessionStorage.removeItem('auth0_return_to');
        history.replace(stored);
      }
    }
  }, [isAuthenticated, history]);

  if (isLoading || !isAuthenticated) {
    return <LoadingScreen />;
  }

  return <>{children}</>;
};

export default Auth0Routes;
